const levels = [
  "Vuggestue",
  "B\xF8rnehave",
  "0. klasse",
  "1. klasse",
  "2. klasse",
  "3. klasse",
  "4. klasse",
  "5. klasse",
  "6. klasse",
  "7. klasse",
  "8. klasse",
  "9. klasse",
  "10. klasse"
];
function transformGradeLevel(input) {
  switch (input.toLowerCase()) {
    case "dagtilbud":
      return {
        id: "Dagtilbud",
        institution: "Dagtilbud",
        sortValue: 1e3
      };
    case "b\xF8rnehaveklassen":
      return {
        id: "B\xF8rnehaveklassen",
        institution: "B\xF8rnehaveklassen",
        sortValue: 1100
      };
    case "0. klasse":
    case "1. klasse":
    case "2. klasse":
    case "3. klasse":
    case "4. klasse":
    case "5. klasse":
    case "6. klasse":
    case "7. klasse":
    case "8. klasse":
    case "9. klasse":
    case "10. klasse": {
      const level = parseInt(input, 10);
      return {
        id: `Grundskole_${level}`,
        institution: "Grundskole",
        level,
        sortValue: 2e3 + level
      };
    }
    case "1 hf":
    case "2 hf": {
      const level = parseInt(input, 10);
      return {
        id: `HF_${level}`,
        institution: "HF",
        level,
        sortValue: 3e3 + level
      };
    }
    case "a-niveau":
    case "b-niveau":
    case "c-niveau": {
      const level = input.charAt(0).toUpperCase();
      return {
        id: `Gymnasium_${level}`,
        institution: "Gymnasium",
        level,
        sortValue: 4e3 + 500 - level.charCodeAt(0)
      };
    }
    default:
      return {
        id: "Andet",
        institution: "Andet",
        level: input,
        sortValue: 5e3
      };
  }
}
function stringifyGradeLevelRange(gradeLevels) {
  const output = [];
  const segments = gradeLevels.reduce(
    (acc, gradeLevel) => {
      switch (gradeLevel.institution) {
        case "Dagtilbud":
        case "B\xF8rnehaveklassen":
          acc.Preschool.push(gradeLevel.institution);
          break;
        case "Grundskole":
          acc.Grundskole.push(gradeLevel.level);
          break;
        case "HF":
          acc.HF.push(gradeLevel.level);
          break;
        case "Gymnasium":
          acc.Gymnasium.push(gradeLevel.level);
          break;
        default:
          acc.Andet.push(gradeLevel.level);
          break;
      }
      return acc;
    },
    {
      Preschool: [],
      Grundskole: [],
      HF: [],
      Gymnasium: [],
      Andet: []
    }
  );
  output.push(...segments.Preschool);
  if (segments.Grundskole.length === 1) {
    output.push(`${segments.Grundskole[0]}. klasse`);
  } else if (segments.Grundskole.length > 1) {
    output.push(
      `${segments.Grundskole[0]}.-${segments.Grundskole[segments.Grundskole.length - 1]}. klasse`
    );
  }
  if (segments.HF.length === 1) {
    output.push(`${segments.HF[0]}. HF`);
  } else if (segments.HF.length > 1) {
    output.push(
      `${segments.HF[0]}.-${segments.HF[segments.HF.length - 1]}. HF`
    );
  }
  if (segments.Gymnasium.length === 1) {
    output.push(`${segments.Gymnasium[0]}-niveau`);
  } else if (segments.Gymnasium.length > 1) {
    output.push(
      `${segments.Gymnasium[0]}-${segments.Gymnasium[segments.Gymnasium.length - 1]}-niveau`
    );
  }
  output.push(...segments.Andet);
  return output.join(", ");
}

export { levels, stringifyGradeLevelRange, transformGradeLevel };
//# sourceMappingURL=levels.js.map
